/* @sravni/react-design-system version 0.2.55 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { FONT_SIZES } from '../../../constants/sizes.js';
import modules_6a168f0b from '../styles/Text.module.less.js';

/**
 * @description The Text component is used for single line or multiline text. The component renders a div element by default
 *
 * @component
 * @example
 * ```jsx
 * <Text as="div" size="xl" strong>Text</Text>
 * ```
 */
var Text = React.forwardRef(function (props, ref) {
    var _a;
    var as = props.as, size = props.size, strong = props.strong, uppercase = props.uppercase, capitalize = props.capitalize, lowercase = props.lowercase, truncate = props.truncate, nowrap = props.nowrap, lineThrough = props.lineThrough, className = props.className, children = props.children, restProps = __rest(props, ["as", "size", "strong", "uppercase", "capitalize", "lowercase", "truncate", "nowrap", "lineThrough", "className", "children"]);
    var cx = useStyles(modules_6a168f0b);
    var classNames = cx(className, (_a = {},
        _a["size-" + size] = true,
        _a.strong = strong,
        _a.uppercase = uppercase,
        _a.capitalize = capitalize,
        _a.lowercase = lowercase,
        _a.truncate = truncate,
        _a.nowrap = nowrap,
        _a.lineThrough = lineThrough,
        _a));
    return React.createElement(as, __assign({ ref: ref, className: classNames }, restProps), children);
});
Text.defaultProps = {
    size: FONT_SIZES.S14,
    as: 'div',
};

export { Text };
//# sourceMappingURL=Text.js.map
